export const name = 'viewerManagerRendererModelApi' as const

export const ViewerManagerRendererAPISymbol = Symbol('ViewerManagerRendererAPI')
export const CSMStoreSymbol = Symbol('CSMStore')
